import { IMediaItem } from "thrive-components";

export const filterTypes: string[] = [
    "Recognition Posts",
    "Comments",
    "Comment Likes",
    "Posts",
    "Likes",
    "Acknowledgements",
    "Moderation Items",
    "Form Responses",
    "Passkey Recovery"
];

export enum UserActivity {
    contentLike = "contentLike", 
    comment = "comment", 
    recognition = "recognition",
    acknowledgementResponse = "acknowledgementResponse", 
    commentReply = "commentReply", 
    contentPosted = "contentPosted",
    commentLike = "commentLike",
    moderatedContentPosted = "moderatedContent",
    moderatedComment = "objectionableComment",
    moderatedRecognition = "moderatedRecognition",
    formResponse = "formResponse",
    accountRecoveryRequest = "accountRecoveryRequest"
} 

export const UserGeneratedActivities = [
    UserActivity.recognition,
    UserActivity.acknowledgementResponse,
    UserActivity.formResponse,
    UserActivity.accountRecoveryRequest
];

export enum AcknowledgementType {
    compliancePost = "compliancePost",
    competitionPost = "competitionPost",
    eventPost = "eventPost"
}

export interface IActivityListProps {
    isPopOut: boolean;
    activities: any,
    showNoMoreActivitiesMessage: boolean;
    getMoreActivities: any
}

export interface IActivityFeedMenuProps {
    onLikeClick?: () => void;
    isLiked?: boolean;
    isReply?: boolean,
    onReplyClick?: () => void;
    getWebLink?: () => string
    onDeleteClick?: () => void;
    onDownloadReportClick?: () => void;
    onApproveContentClick?: () => void,
    onArchiveContentClick?: () => void;
    onDownloadCSVClick?: () => void;
    userPageLink?: string;
}

export interface IUserCommentProps { 
    zIndexNum?: number,
    commentText: string, 
    isReply?: boolean, 
    truncateNumber: number, 
    isOriginalComment?: boolean, 
    hideMenu?: boolean,
    className?: string, 
    onLikeClick?: ()=>void, 
    isLiked?: boolean, 
    onReplyClick?: ()=>void, 
    getWebLink?: ()=>string, 
    onDeleteClick?: ()=>void
}

export interface IContentTitleProps extends IActivityFeedMenuProps {
    zIndexNum?: number,
    contentTitle: string, 
    className?: string
    showMenu?: boolean
    isItalic?: boolean
}

export interface ICommentInputPanelProps {
    className?: string,
    onPostCommentClick: ()=>void,
    commentString: string,
    setCommentString: (commentString: string)=>void,
    showCommentFunctionality: boolean,
    setShowCommentFunctionality: (show: boolean)=>void,
    profileImageUrl: string;
    isPosting: boolean;
}

export interface IActivityInformationPanel {
    appImageUrl?: string;
    appName?: string;
    className?: string;
    time?: string;
    dateStamp?: string,
    contentTitle?: string;
    contentLink?: string;
    contentExistsInMultiplePlaces?: boolean;
    likes?: number;
    comments?: number;
    isReply?: boolean;
    recognitionValue?: string;
    likesEnabled?: boolean,
    commentsEnabled?: boolean
}

export interface IUserReplyProps {
    zIndexNum?: number,
    className?: string;
    hideMenu?: boolean,
    originalText: string; 
    replyText: string;
    truncateNumber: number;
    getOpenOnWebLink?:()=>string; 
    onLikeClick?:()=>void;
    isLiked?:boolean;
    onDeleteCommentClick?: ()=>void;
}

export interface IDeleteCommentProps {
    showModal: boolean,
    onCloseClick: ()=> void;
    onConfirmClick: ()=>void;
    isInlineStyle?: boolean
}

export interface IArchiveContentProps extends IDeleteCommentProps { existsInMultiplePlaces?: boolean }


export interface IActivityFeedFilterParams {
    workspaceIds: number[],
    filter: string[],
    startDate: string,
    endDate: string
	top: number,
	skip: number,
}

export interface IActivityProps {
    zIndexNum?: number;
    isPopOut?: boolean;
    activity: any
}

export interface IReportFilterParams {
    workspaceIds: number[],
    filter: string[],
    startDate: string,
    endDate: string
}

export interface BannerNotification {
    activityId: string;
    isSuccess: boolean;
    message: string;
};

export interface Author {
    id: number,
    displayName: string,
    profilePicture: {
        contentType: string,
        url: string
    }
}
      
export interface ObjectionableComment {
    commentAuthor: Author; 
    commentId: number,
    commentText: string, 
    isDeleted?: boolean, 
    objectionableMessage?: string | null;
}

export interface Workspace {
  	    id: number,
  	    name: string,
 	    icon: {
            contentType: string,
            url: string
        },
  	    appGuid: string
}

export interface Meta {
    metaType: string,
    likeCount: number,
    commentCount: number,
    hasLiked: boolean,
    commentsEnabled: boolean,
    likesEnabled: boolean,
    client?: string,
}
      
export interface ParentList {
    id: number,
    title: string
}
      
export interface ContentItem {
    id: number,
    title: string,
    contentAuthor: Author
    isArchived: boolean
}

export interface MediaItem {
    mediaType: string,
    contentType: string,
    url?: string,
    fileName: string,
    thumbnail: {
        url?: string,
        contentType?: string
    }
}

export interface MediaObject {
    total: number
    items: IMediaItem[]
}

export interface ExtendedContentItem {
    id: number,
    title: string,
    contentAuthor: Author
    isArchived: boolean,
    media: MediaObject
}

export interface UniqueActivityKey {
    type: 'comment' | 'comment-like' | 'comment-reply',
    activity: {
        comment: {
            id: number
        },
        author: {
            id: number
        }
        createdAt: string
    }
}